module.exports = __webpack_public_path__ + "static/fonts/rajdhani-light-webfont.45f23aa.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-light-webfont.woff
// module id = 97
// module chunks = 0